<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/dashboard" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Questions</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn to="/questions/add" class="mx-2 my-0" color="success" depressed small>
      <v-icon class="mr-1" left small>add</v-icon>
      <span>Add</span>
    </v-btn>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3 pb-2" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-3 pb-3" xs12>
      <v-layout row wrap justify-center>
        <v-flex class="-hidden-sm-and-down" xs6 md2>
          <v-menu max-height="300px" full-width offset-y>
            <v-btn slot="activator" color="white" class="my-0 elevation-0" block large>
              <span><b>{{searchType}} search</b></span>
              <v-icon class="ml-0" right>arrow_drop_down</v-icon>
            </v-btn>
            <v-list>
              <template v-for="p in ['Default', 'Number', 'Tag', 'Areas']">
                <v-list-tile v-if="searchType == p" :key="p">
                  <v-list-tile-title class="grey--text text--lighten-1">
                    <b>{{p}}</b>
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-else :key="p" @click="searchType = p, searchQuery = '', tagQuery = [], areaQuery = []">
                  <v-list-tile-title>
                    <b>{{p}}</b>
                  </v-list-tile-title>
                </v-list-tile>
              </template>
            </v-list>
          </v-menu>
        </v-flex>
        <template v-if="searchType == 'Areas'">
          <v-flex class="px-1" xs12 sm6 md4>
            <v-select
              class="elevation-1"
              label="Search PN/RN"
              v-model="searchQuery"
              :items="['PN', 'RN']"
              prepend-icon="search"
              solo
            ></v-select>
          </v-flex>
          <v-flex class="px-1" xs12 sm6 md4>
            <v-select
              class="elevation-1"
              label="Search Areas"
              v-model="areaQuery"
              :items="allAreas"
              prepend-icon="search"
              multiple
              solo
            ></v-select>
          </v-flex>
        </template>
        <v-flex class="px-1" v-else xs12 md8>
          <v-select
            v-if="searchType == 'Tag'"
            class="elevation-1"
            label="Search"
            v-model="tagQuery"
            :items="allTags"
            prepend-icon="search"
            multiple
            solo
          ></v-select>
          <v-text-field
            v-else
            class="elevation-1"
            label="Search"
            @keyup.enter="search"
            v-model.trim="searchQuery"
            prepend-icon="search"
            :append-icon="searchQuery.length > 0 ? 'close' : ''"
            :append-icon-cb="() => (searchQuery = '', listed = [])"
            solo
          ></v-text-field>
        </v-flex>
        <v-flex class="-hidden-sm-and-down" xs6 md2>
          <v-btn @click.native="search" class="my-0 elevation-0" color="success" block large flat>
            <b>Search</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 md10>
      <v-card class="px-2 pb-2" flat>
        <v-layout row wrap justify-center>
          <v-flex v-if="loading" class="py-5 my-5" xs12>
            <div class="text-xs-center display-3 grey--text text--lighten-1">
              <v-progress-circular color="accent" indeterminate></v-progress-circular>
            </div>
          </v-flex>
          <template v-else>
            <v-flex v-if="listed.length == 0" class="py-5 my-5" xs12>
              <div class="text-xs-center display-3 grey--text text--lighten-1">
                {{questions.length + ' Question'}}{{questions.length == 1 ? '' : 's'}}
              </div>
            </v-flex>
            <template v-else>
              <v-flex class="px-2 pb-4 text-xs-center secondary--text title" xs12>
                <div class="title pb-2">
                  <b>{{listed.length}}{{listed.length == 1 ? ' result' : ' results'}}</b>
                </div>
                <div class="subheading">
                  <b>50 questions per page</b>
                </div>
              </v-flex>
              <v-flex class="px-2 pb-3" xs12 md8>
                <v-layout row>
                  <v-flex class="text-xs-right" xs>
                    <v-btn
                      @click.native="currentPage = currentPage - 1"
                      class="my-0"
                      color="primary"
                      :disabled="currentPage == 0"
                      icon
                      flat
                    >
                      <b><v-icon medium>chevron_left</v-icon></b>
                    </v-btn>
                  </v-flex>
                  <v-flex xs>
                    <v-menu max-height="300px" full-width offset-y>
                      <v-btn slot="activator" color="primary" class="my-0" flat block>
                        <span><b>Page {{currentPage + 1}}</b></span>
                      </v-btn>
                      <v-list>
                        <template v-for="p, i in pages">
                          <v-list-tile v-if="currentPage == i" :key="i">
                            <v-list-tile-title class="grey--text text--lighten-1">
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-else :key="i" @click="currentPage = i">
                            <v-list-tile-title>
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      @click.native="currentPage = currentPage + 1"
                      class="my-0"
                      color="primary"
                      :disabled="(currentPage + 1) == pages.length"
                      icon
                      flat
                    >
                      <b><v-icon medium>chevron_right</v-icon></b>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-for="question in pages[currentPage]" :key="question.id" class="px-2 pb-4" xs12 md6>
                <v-card class="pa-2 elevation-1 grey lighten-4">
                  <v-layout row wrap justify-center>
                    <v-flex class="pt-2 text-xs-center" xs12>
                      <span class="secondary--text title"><b>{{question.id}}</b></span>
                    </v-flex>
                    <v-flex class="pt-2" xs10>
                      <v-divider></v-divider>
                    </v-flex>
                    <v-flex class="px-2 pt-2" xs12>
                      <v-layout class="subheading" row wrap>
                        <v-flex class="pb-2" xs12>
                          <b>Tags: </b>
                          <v-chip class="my-0" v-for="tag in question.tags" :key="tag" disabled small>
                            {{tag}}
                          </v-chip>
                        </v-flex>
                        <v-flex class="pb-2" xs12>
                          <b>NCLEX Area(s): </b>
                          <span v-if="question.area"><v-chip  class="my-0" v-for="area in question.area" :key="area" disabled small>
                            {{area}}
                          </v-chip></span>
                          <span v-else>None</span>
                        </v-flex>
                        <v-flex xs12><span><b>Question:</b></span></v-flex>
                        <v-flex class="pb-2" xs12>
                          <div>{{question.body[0].toUpperCase() + question.body.slice(1, 70)}}{{question.body.length > 70 ? '...' : ''}}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="pb-2 text-xs-center" xs12>
                      <v-btn :to="'/questions/' + question.id" color="primary" class="my-0" flat><b>View</b></v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex class="px-2 pb-2" xs12 md8>
                <v-layout row>
                  <v-flex class="text-xs-right" xs>
                    <v-btn
                      @click.native="currentPage = currentPage - 1"
                      class="my-0"
                      color="primary"
                      :disabled="currentPage == 0"
                      icon
                      flat
                    >
                      <b><v-icon medium>chevron_left</v-icon></b>
                    </v-btn>
                  </v-flex>
                  <v-flex xs>
                    <v-menu max-height="300px" full-width offset-y top>
                      <v-btn slot="activator" color="primary" class="my-0" flat block>
                        <span><b>Page {{currentPage + 1}}</b></span>
                      </v-btn>
                      <v-list>
                        <template v-for="p, i in pages">
                          <v-list-tile v-if="currentPage == i" :key="i">
                            <v-list-tile-title class="grey--text text--lighten-1">
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-else :key="i" @click="currentPage = i">
                            <v-list-tile-title>
                              <b>Page {{ i+1 }}</b>
                            </v-list-tile-title>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs>
                    <v-btn
                      @click.native="currentPage = currentPage + 1"
                      class="my-0"
                      color="primary"
                      :disabled="(currentPage + 1) == pages.length"
                      icon
                      flat
                    >
                      <b><v-icon medium>chevron_right</v-icon></b>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </template>
          </template>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    searchType: 'Default',
    searchQuery: '',
    areaQuery: [],
    tagQuery: [],
    questions: [],
    allTags: [],
    allAreas: [],
    listed: [],
    pages: [],
    currentPage: 0
  }),
  beforeMount () {
    this.questions = [...this.$store.getters.questions]
    this.allTags = this.$store.getters.tags
    this.allAreas = this.$store.getters.nclexAreas
  },
  methods: {
    search () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      this.listed = []
      if (this.searchQuery.length === 0 && this.searchType !== 'Tag' && this.searchType !== 'Areas') return
      this.loading = true
      if (this.searchType === 'Default') {
        for (let i = 0; i < this.questions.length; i++) {
          if (this.questions[i].data.includes(this.searchQuery.toLowerCase())) {
            this.listed.push({...this.questions[i]})
          }
        }
      } else if (this.searchType === 'Number') {
        if (/^\d+$/.test(this.searchQuery)) {
          for (let i = 0; i < this.questions.length; i++) {
            if (this.questions[i].id === +this.searchQuery) {
              this.listed.push({...this.questions[i]})
            }
          }
        } else {
          appMsg.msg = 'Please type only digits to search or change search type'
          this.$store.dispatch('showAppMsg', appMsg)
        }
      } else if (this.searchType === 'Tag') {
        if (this.tagQuery.length > 0) {
          for (let i = 0; i < this.questions.length; i++) {
            let tagsFound = true
            for (let j = 0; j < this.tagQuery.length; j++) {
              if (!this.questions[i].tags.includes(this.tagQuery[j])) tagsFound = false
            }
            if (tagsFound) this.listed.push({...this.questions[i]})
          }
        } else {
          appMsg.msg = 'Please select tags to search or change search type'
          this.$store.dispatch('showAppMsg', appMsg)
        }
      } else if (this.searchType === 'Areas') {
        if (this.searchQuery.length > 0 && this.areaQuery.length > 0) {
          for (let i = 0; i < this.questions.length; i++) {
            let tagsFound = true
            if (this.questions[i].area) {
              for (let j = 0; j < this.areaQuery.length; j++) {
                if (!this.questions[i].area.includes(this.areaQuery[j]) || !this.questions[i].tags.includes(this.searchQuery)) {
                  tagsFound = false
                }
              }
              if (tagsFound) this.listed.push({...this.questions[i]})
            }
          }
        } else {
          appMsg.msg = 'Please select RN or PN with NCLEX Areas to search or change search type'
          this.$store.dispatch('showAppMsg', appMsg)
        }
      }
      // create pages
      this.pages = []
      let i = 0
      let pageNum = 0
      while (i < this.listed.length) {
        this.pages.push([])
        while (this.pages[pageNum].length < 50) {
          if (i === this.listed.length) break
          this.pages[pageNum].push({...this.listed[i]})
          i++
        }
        pageNum++
      }
      this.currentPage = 0
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/QuestionList.vue